import React from 'react';
import { getRiskLevel } from '../utils/riskCalculations';
import { STYLES } from '../constants/styles';
import { ProgressBar } from './ui/ProgressBar';
import { classNames, variantClass } from '../utils/classNames';

interface VulnerabilityScoreProps {
  label: string;
  score: number;
  icon: React.ReactNode;
  color: 'red' | 'yellow' | 'green';
}

export const VulnerabilityScore: React.FC<VulnerabilityScoreProps> = ({ 
  label, 
  score, 
  icon, 
  color 
}) => {
  const colors = variantClass(color, STYLES.COLORS);
  const vulnerabilityLevel = getRiskLevel(score);

  return (
    <div className={classNames(
      'p-4 rounded-lg border',
      colors.BG,
      colors.BORDER
    )}>
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center space-x-2">
          <span className={colors.ICON}>{icon}</span>
          <span className="font-medium text-gray-900">{label}</span>
        </div>
        <span className={classNames('text-sm font-bold', colors.TEXT)}>
          {vulnerabilityLevel}
        </span>
      </div>
      <div className="mb-2">
        <div className="flex justify-between items-center mb-1">
          <span className="text-2xl font-bold text-gray-900">{score}</span>
          <span className="text-sm text-gray-600">/ 100</span>
        </div>
        <ProgressBar
          value={score}
          max={100}
          color={color}
          size="md"
        />
      </div>
    </div>
  );
};